import {
  TOktaApiResponse,
  TOktaApiSMSFactor,
  TOktaApiEmailFactor,
  TOktaMFAFactor,
} from '../interfaces';

function getFactor<TFactorType extends TOktaApiSMSFactor | TOktaApiEmailFactor>(
  factorType: TOktaMFAFactor
) {
  return (factors: (TOktaApiEmailFactor | TOktaApiSMSFactor)[]) =>
    factors.find((f): f is TFactorType => f.factorType === factorType);
}

export const getSmsFactor = getFactor<TOktaApiSMSFactor>('sms');
export const getEmailFactor = getFactor<TOktaApiEmailFactor>('email');
